import { render, staticRenderFns } from "./OrderCreateWalletModal.vue?vue&type=template&id=7ca1882d&"
import script from "./OrderCreateWalletModal.vue?vue&type=script&lang=js&"
export * from "./OrderCreateWalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports